import PropTypes from 'prop-types';
import React from 'react';

const GithubMenuItem = ({user}) => (
  <div>
    <img
      alt={user.name}
      src={user.staffimageid}
      style={{
        height: '24px',
        marginRight: '10px',
        width: '24px',
      }}
    />
    <span>{user.name}</span>
  </div>
);

GithubMenuItem.propTypes = {
  user: PropTypes.shape({
    staffimageid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default GithubMenuItem;